import LoginPage from '@/views/Auth/LoginPage.vue'
import { AuthGuard } from '@/router/guards/AuthGuard'
import RegistrationPage from '@/views/Registration/RegistrationPage.vue'
import ForgotPasswordPage from '@/views/Auth/ForgotPasswordPage.vue'
import ResetPasswordPage from '@/views/Auth/ResetPasswordPage.vue'
import TwoFactorVerificationPage from '@/views/Auth/TwoFactorVerificationPage.vue'
import AddProfileInfoPage from '@/views/Registration/AddProfileInfoPage.vue'
import LoginSuccessPage from '@/views/Auth/LoginSuccessPage.vue'
import AddOrganizationRolePage from '@/views/Registration/AddOrganizationRolePage.vue'
import SignupSuccessPage from '@/views/Registration/SignupSuccessPage.vue'
import FindOrganizationPage from '@/views/Registration/FindOrganizationPage.vue'
import InviteAcceptPage from '@/views/Auth/InviteAcceptPage.vue'

export default [
	{
		path: '/auth/login',
		name: 'auth.login',
		component: LoginPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedOut,
			title: 'Login'
		}
	},
	{
		path: '/auth/register',
		name: 'auth.register',
		component: RegistrationPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedOut,
			title: 'Register'
		}
	},
	{
		path: '/auth/verify-tfa',
		name: 'auth.verify-tfa',
		component: TwoFactorVerificationPage,
		props: true,
		meta: {
			authGuard: AuthGuard.RequireLoggedOut,
			title: 'Verification'
		}
	},
	{
		path: '/auth/forgot-password',
		name: 'auth.forgot-password',
		component: ForgotPasswordPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedOut,
			title: 'Forgot Password'
		}
	},
	{
		path: '/auth/reset-password',
		name: 'auth.reset-password',
		component: ResetPasswordPage,
		meta: {
			authGuard: AuthGuard.NoEnforcement,
			title: 'Reset Password'
		}
	},
	{
		path: '/auth/add-profile-info',
		name: 'auth.add-profile-info',
		component: AddProfileInfoPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Add profile information'
		}
	},
	{
		path: '/auth/find-organization',
		name: 'auth.find-organization',
		component: FindOrganizationPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Find organization'
		}
	},
	{
		path: '/auth/add-organization-role',
		name: 'auth.add-organization-role',
		component: AddOrganizationRolePage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Add organization role'
		}
	},
	{
		path: '/auth/login-success',
		name: 'auth.login-success',
		component: LoginSuccessPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Login success'
		}
	},
	{
		path: '/auth/signup-success',
		name: 'auth.signup-success',
		component: SignupSuccessPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Signup success'
		}
	},
	// {
	// 	path: '/auth/before-we-continue',
	// 	name: 'auth.before-we-continue',
	// 	component: BeforeWeContinuePage,
	// 	meta: {
	// 		authGuard: AuthGuard.RequireLoggedIn,
	// 		title: 'Login success'
	// 	}
	// },
	{
		path: '/invite/accept',
		name: 'auth.invite-accept',
		component: InviteAcceptPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedOut,
			title: 'User Invite'
		}
	}
]
